import { Stack } from 'expo-router';

import PlatformContainer from '@/components/web/PlatformContainer.web';

export default function ProgramDetailLayout() {
  return (
    <PlatformContainer contentCustomClassnames="flex flex-col">
      <Stack>
        <Stack.Screen name="[programId]" />
      </Stack>
    </PlatformContainer>
  );
}
